<template>
  <div class="scroll_flex_container">
    <navbar title="紅利積分"></navbar>
    <div class="scroll_flex_container">
      <div class="row_center_center total_bouns">
        <div class="column_center_center points_section">
          <text class="current_bouns_text">現有積分</text>
          <text class="current_bouns">{{ totalPoints }}</text>
          <!-- <text class="exchange_rate">100元=1積點</text> -->
        </div>
        <div class="qrcode_section">
          <QRCode :value="memberQrCode" :size="100" level="H" renderAs="svg" />
        </div>
      </div>
      <div class="column_center_start" style="width: 100%; padding: 10px 0;">
        <bounsHistory v-for="(item, index) in pointHistoryList" :key="index" :item="item"></bounsHistory>
      </div>
    </div>
  </div>
</template>
<script>
import navbar from "@/components/general/navbar.vue"
import commonUtils from "@/utils/common.utils";
import auth from "@/utils/auth.utils"
import { mapState, mapGetters } from 'vuex'
import bounsHistory from '@/components/bouns/bounsHistory.vue'
import QRCode from 'qrcode.vue'
export default {
  components: {
    navbar,
    bounsHistory,
    QRCode
  },
  computed: {
    ...mapGetters('userData', {
      totalPoints: 'totalPoints',
      pointHistoryList: 'pointHistoryList',
      isLogin: 'isLogin',
      memberQrCode: 'memberQrCode'
    }),
    ...mapState('basic', {
      currentStore: 'currentStore',
    })
  },
  async mounted() {
    if (!this.isLogin) {
      commonUtils.createToast("warning", "登入狀態已過期，請重新登入");
      await commonUtils.delay(1500)
      auth.logout()
      this.$router.push({
        path: `/${this.currentStore}`
      })
      return
    }
    try {
      commonUtils.createLoading("資料讀取中", "請稍後");
      // 將 pointHistoryPage 設為 0
      this.$store.commit('userData/setPointHistoryPage', 0)
      await this.$store.dispatch('userData/fetchPointHistory')
    } catch (e) {
      console.log('fetch user point history error', e)
    } finally {
      await commonUtils.delay(1000)
      commonUtils.closeLoading();
    }
    // 取得最新的會員資料更新總點數
    try {
      await this.$store.dispatch('userData/fetchMemberInfo')
    } catch (e) {
      console.log('fetch user data error', e)
    }
  },
  methods: {},
};
</script>
<style lang="scss">
.total_bouns {
  background-color: #fff;
  width: 100%;
  height: 180px;
  flex-shrink: 0;
  padding: 0 20px;
  justify-content: center;

  .points_section {
    flex: 0 0 auto;
    margin-right: 20px;
  }

  .qrcode_section {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
  }

  .exchange_rate {
    font-size: 16px;
    color: #797979;
  }

  .current_bouns {
    margin: 0px;
    font-weight: 900;
    font-size: 56px;
    color: #FD5001;
  }

  .current_bouns_text {
    font-size: 20px;
    font-weight: 500;
    color: #000;
  }
}
</style>
